import { CheckSquare, Plus } from 'lucide-react';
import { useEffect, useState } from 'react';
import './ProjectTasks.css';

import { API_URL } from '../../config/api'
interface Task { id: number; title: string; description: string; status: 'todo' | 'in_progress' | 'completed'; priority: 'low' | 'medium' | 'high'; assigned_to: number | null; agent_name?: string; created_at: string }
interface ProjectTasksProps { projectId: number }

export default function ProjectTasks({ projectId }: ProjectTasksProps) {
  const [tasks, setTasks] = useState<Task[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadTasks = async () => {
      try {
        const res = await fetch(`${API_URL}/api/projects/${projectId}/tasks`)
        const data = await res.json()
        const taskList = data.tasks as Task[]
        setTasks(taskList || [])
      } catch (err) {
        console.error('Tasks load error:', err)
      } finally {
        setLoading(false)
      }
    }
    void loadTasks()
  }, [projectId])

  const getTasksByStatus = (status: Task['status']) => tasks.filter(t => t.status === status)

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>
  }

  return (
    <div className="tasks-container">
      <div className="tasks-header">
        <h2 className="section-title">Tasks</h2>
        <button className="add-task-btn"><Plus size={16} /> Add Task</button>
      </div>

      {tasks.length === 0 ? (
        <div className="tasks-empty"><CheckSquare size={64} /><h3>No tasks yet</h3><p>Create your first task to get started</p></div>
      ) : (
        <div className="kanban-board">
          {(['todo', 'in_progress', 'completed'] as const).map(status => {
            const statusTasks = getTasksByStatus(status)
            const statusLabels = { todo: 'To Do', in_progress: 'In Progress', completed: 'Completed' }
            return (
              <div key={status} className="kanban-column">
                <div className="column-header">
                  <span className="column-title">{statusLabels[status]}</span>
                  <span className="column-count">{statusTasks.length}</span>
                </div>
                <div className="tasks-list">
                  {statusTasks.map(task => (
                    <div key={task.id} className="task-card">
                      <div className="task-title">{task.title}</div>
                      {task.description && <div className="task-description">{task.description}</div>}
                      <div className="task-meta">
                        <span className={`task-priority ${task.priority}`}>{task.priority.toUpperCase()}</span>
                        {task.agent_name && (
                          <div className="task-assignee">
                            <div className="task-avatar">{task.agent_name.charAt(0).toUpperCase()}</div>
                            <span>{task.agent_name}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
